// ./utils/api-endpoints/employee-files.ts

export const employeeFileEndpoints: Record<string, string> = {
    getEmployeeFilesByFilter: '/api/EmployeeFolder/Filter',
    getEmployeeFolderByEmployeeId: '/api/EmployeeFolder/GetByEmployeeId',
    
    getEmployeeFolderByFolderId: '/api/EmployeeFolder/GetByFolderId',

    getEmployeeFolderMembersByFolderId: '/api/EmployeeFolderMember/GetFolderMembers',

    createEmployeeFolder: '/api/EmployeeFolder/Insert',
    updateEmployeeFolder: '/api/EmployeeFolder/Update',
    updateEmployeeFolderShare: '/api/EmployeeFolder/Share',
    deleteEmployeeFolder: '/api/EmployeeFolder/Delete',


    uploadEmployeeFile: '/api/EmployeeFile/Upload',
    createEmployeeFile: '/api/EmployeeFile/Insert',
    deleteEmployeeFile: '/api/EmployeeFile/Delete',
    updateEmployeeFile: '/api/EmployeeFolder/Update',
    shareEmployeeFile: '/api/EmployeeFolder/Share',

    editEmployeeFolder: '/api/EmployeeFolder/Update',
    editProjectFolder: '/api/ProjectFolder/Update',
    editClientFolder: '/api/ClientFolder/Update',


  };
  